/* @flow */
import * as React from "react";

type Props = {
  focused: boolean,
  onFocusExited: () => void,
  children: ({
    captureTargetRef: (?HTMLElement) => void,
  }) => React.Node,
};

export default class FocusController extends React.Component<Props> {
  _target: ?HTMLElement = null;
  _previousActiveElement: ?HTMLElement = null;

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (this.props.focused === nextProps.focused) {
      return;
    }

    this._updateFocus({
      target: this._target,
      focused: nextProps.focused,
    });
  }

  _handleTargetRef = (el: ?HTMLElement) => {
    if (el === this._target) {
      return;
    }

    this._target = el;
    this._updateFocus({
      target: el,
      focused: this.props.focused,
    });
  };

  _updateFocus(next: { target: ?HTMLElement, focused: boolean }) {
    const { target, focused } = next;
    if (target && focused) {
      this._focusTarget(target);
    } else {
      this._returnFocus();
    }
  }

  _focusTarget(target: HTMLElement) {
    this._previousActiveElement = document.activeElement;
    target.focus();
    window.addEventListener("focusin", this._onFocusIn);
  }

  _returnFocus() {
    const prev = this._previousActiveElement;
    if (prev == null) {
      return;
    }
    prev.focus();
    this._previousActiveElement = null;
    window.removeEventListener("focusin", this._onFocusIn);
  }

  _onFocusIn = (event: { /* :: ...Event, */ target: HTMLElement }) => {
    if (!this._target) {
      return;
    }
    if (this._target.contains(event.target)) {
      return;
    }

    this.props.onFocusExited();
  };

  render() {
    return this.props.children({
      captureTargetRef: this._handleTargetRef,
    });
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/FocusController.jsx